/**
 * Image utilities.
 */
export class Image {
    /**
     * Generates the content for the src tag of an image from a base64 image.
     * @param base64Image Base64 image.
     */
    static getImgSrcForBase64(base64Image: string): string {
        return `data:image/png;base64,${base64Image}`;
    }
}
